import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UploadFolderEnum } from '@fleet-beat/api';
import { AuthHeaders, BaseApiService, CoreInjectorTokens, Environment, ResponseDto } from '@fleet-beat/core';
import { Observable, catchError, map, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UploadApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}/upload`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
    private http: HttpClient,
  ) {}

  uploadFile(file: File, folder: UploadFolderEnum, auth: AuthHeaders): Observable<string> {
    if (!file) return of('');
    const contentType: string = file.type || 'application/octet-stream';
    const key: string = `${folder}/${new Date().getTime()}${file.name}`;
    return this.getUploadLink(key, contentType, auth).pipe(
      switchMap((url: string) =>
        this.baseApiService.put(url, file, { headers: { 'Content-Type': contentType } }).pipe(
          catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
          map(() => {
            const parsed: URL = new URL(url);
            parsed.search = '';
            return parsed.toString();
          }),
        ),
      ),
    );
  }

  private getUploadLink(key: string, contentType: string, auth: AuthHeaders): Observable<string> {
    return this.baseApiService.post(`${this.baseUrl}/get-presigned-url`, { key, contentType }, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<string>) => this.baseApiService.mapResponse(response)),
    );
  }
}
